import { ITransferRequest } from './../../../../_models/transfer-sections/ITransferRequest';
import { SettingService } from './../../../../shared/services/setting.service';
import { CommonService } from './../../../../shared/services/common.service';
import { TransferRequestService } from './../../../../shared/services/transfer-request.service';
import { ProfileService } from './../../../../shared/services/profile.service';
import { ISetting } from './../../../../_models/cms/ISetting';
import { IKeyValuePair } from './../../../../_models/common/common';
import { IProfile } from './../../../../_models/account/IProfile';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html'
})
export class ProfileFormComponent implements OnInit {
  year: number = new Date().getFullYear();

  titles: string[] = ["Mr.", "Mrs.", "Ms."];
  loading: boolean;
  skeleton: boolean = true;
  title: string = 'Add Profile';
  profile: IProfile;
  profileForm: FormGroup;
  id;
  financialYearId;

  religions: IKeyValuePair[];
  genders: IKeyValuePair[];
  regions: IKeyValuePair[];
  recruitmentCategories: IKeyValuePair[];
  categories: IKeyValuePair[];
  states: IKeyValuePair[];
  homeDistricts: IKeyValuePair[];
  presentDistricts: IKeyValuePair[];
  permanentDistricts: IKeyValuePair[];

  setting: ISetting;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private service: ProfileService,
    private transferRequestService: TransferRequestService,
    private commonService: CommonService,
    private settingService: SettingService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.financialYearId = this.route.snapshot.paramMap.get('financialYearId');
  }

  async ngOnInit() {
    this.createProfileForm();

    this.setting = await this.settingService.getSetting();

    this.setProfileValidators();
    this.bindDropDown();

    this.service.get(this.id).subscribe((response: IProfile) => {
      if (response) {
        this.getTransferRequest();
        this.profile = response;
        this.title = 'Edit Profile';
        this.id = response.userId;
        this.setValueProfileForm();
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.skeleton = false);
  }
  goBack(): void {
    window.history.back();
  }
  getTransferRequest() {
    this.transferRequestService.logged().subscribe((response: ITransferRequest) => {
      if (response) {
        if (response.isConfirm) {
          this.toastrService.warning("You have already confirm application. You are not able to edit.");
          this.router.navigate(['/employee']);
        }
      }
    });
  }

  bindDropDown() {
    this.commonService.getRegions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.regions = response.filter(x => x.text == "Chandigarh" || x.text == "Shillong");
      }
    });

    this.commonService.getStates().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });

    this.commonService.getReligions().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.religions = response;
      }
    });

    this.commonService.getGenders().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.genders = response;
      }
    });

    this.commonService.getCategories().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.categories = response;
      }
    });

    this.commonService.getRecruitmentCategories().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.recruitmentCategories = response;
      }
    });
  }

  getHomeDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.homeDistricts = response;
      }
    });
  }

  getPresentDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.presentDistricts = response;
      }
    });
  }

  getPermanentDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.permanentDistricts = response;
      }
    });
  }


  setProfileValidators() {
    const specReqDriveYearControl = this.profileForm.get('specReqDriveYear');
    const appointRegionIdControl = this.profileForm.get('appointRegionId');
    const otherReligionControl = this.profileForm.get('otherReligion');

    this.profileForm.get('isSpecReqDrive').valueChanges
      .subscribe(isSpecReqDrive => {
        if (isSpecReqDrive) {
          specReqDriveYearControl.setValidators([Validators.required]);
          appointRegionIdControl.setValidators([Validators.required]);
        }
        else {
          specReqDriveYearControl.setValidators(null);
          appointRegionIdControl.setValidators(null);
        }

        specReqDriveYearControl.updateValueAndValidity();
        appointRegionIdControl.updateValueAndValidity();
      });

    this.profileForm.get('religionId').valueChanges
      .subscribe(religionId => {
        if (religionId == 99) {
          otherReligionControl.setValidators([Validators.required]);
        }
        else {
          otherReligionControl.setValidators(null);
        }

        otherReligionControl.updateValueAndValidity();
      });
  }

  createProfileForm() {
    this.profileForm = this.fb.group({
      userId: [''],
      title: ['', Validators.required],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: [''],
      retirementDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      nvsJoiningDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      homeStateId: ['', Validators.required],
      homeDistrictId: ['', Validators.required],
      aadharCardNo: ['', [Validators.required, Validators.pattern('^[0-9]{12}$')]],
      genderId: ['', Validators.required],
      religionId: ['', Validators.required],
      otherReligion: [''],
      npS_No: [''],
      cpF_No: [''],
      birthDate: ['', [Validators.required, Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      categoryId: ['', Validators.required],
      recruitmentCategoryId: ['', Validators.required],
      isSpecReqDrive: [false, Validators.required],
      specReqDriveYear: [null],
      appointRegionId: [null],
      specJoiningDate: [null, [Validators.pattern("[0-9]{2}[-][0-9]{2}[-][0-9]{4}")]],
      isActive: [true, Validators.required],
      //isRetirementNear: [false, Validators.required],
    });
  }

  setValueProfileForm() {

    if (this.profile.homeStateId) {
      this.getHomeDistricts(this.profile.homeStateId);
    }

    this.profileForm.patchValue({
      userId: this.profile.userId,
      title: this.profile.title,
      firstName: this.profile.firstName,
      middleName: this.profile.middleName,
      lastName: this.profile.lastName,
      retirementDate: this.datePipe.transform(this.profile.retirementDate, 'dd-MM-yyyy'),
      nvsJoiningDate: this.datePipe.transform(this.profile.nvsJoiningDate, 'dd-MM-yyyy'),
      homeStateId: this.profile.homeStateId,
      homeDistrictId: this.profile.homeDistrictId,
      aadharCardNo: this.profile.aadharCardNo,
      genderId: this.profile.genderId,
      religionId: this.profile.religionId,
      otherReligion: this.profile.otherReligion,
      npS_No: this.profile.npS_No,
      cpF_No: this.profile.cpF_No,
      birthDate: this.datePipe.transform(this.profile.birthDate, 'dd-MM-yyyy'),
      categoryId: this.profile.categoryId,
      recruitmentCategoryId: this.profile.recruitmentCategoryId == null ? '' : this.profile.recruitmentCategoryId,
      isSpecReqDrive: this.profile.isSpecReqDrive,
      specReqDriveYear: this.profile.specReqDriveYear,
      appointRegionId: this.profile.appointRegionId,
      //isRetirementNear: this.profile.isRetirementNear,
      specJoiningDate: this.profile.specJoiningDate ? this.datePipe.transform(this.profile.specJoiningDate, 'dd-MM-yyyy') : null,
      isActive: this.profile.isActive
    });
  }

  save() {
    if (this.profileForm.valid) {
      this.loading = true;
      this.profile = Object.assign({}, this.profileForm.value);
      this.service.update(this.id, this.profile).subscribe(() => {
        this.toastrService.success('profile updated successful');
        this.router.navigate(['/school/employees/view', this.id,this.financialYearId]);
      },
        (error) => console.log('HTTP Error', error),
        () => this.loading = false);
    }
  }
  
  changeBirthDate() {
    if (this.profileForm.get('birthDate').valid) {
      let birthDate = this.profileForm.get('birthDate').value;
      let d: string[] = birthDate.split("-");
      let day = +d[0];
      let month = +d[1];
      if (day <= 1) month = month - 1;
      let f = new Date(+d[2], month, 0);
      let rDate = new Date(f.setFullYear(f.getFullYear() + 60));
      this.profileForm.patchValue({
        retirementDate: this.datePipe.transform(rDate, 'dd-MM-yyyy')
      });
    }
  }

}
